import { getMemberInfo } from 'components/RouterRoot/selectors';
import { useSelector } from 'react-redux';
import { Member } from 'types';

export default function useMemberInfo(): [Member | undefined] {
  const memberInfo: Member = useSelector(getMemberInfo);

  return [memberInfo];
}
